import * as NavbarCollapse from './../modules/NavbarCollapse';
import * as Collapsable from '../modules/Collapsable';
import * as sliders from '../modules/sliders';
import * as newsGrid from '../modules/news-grid';
import * as cart from '../modules/cart';
import * as video from '../modules/video';
import * as modals from '../modules/modals';

export default {
  init() {
    // JavaScript to be fired on all pages
    NavbarCollapse.init();
    newsGrid.init();
    sliders.init();
    Collapsable.init();
    cart.init();
    video.init();
    modals.init();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js